/* ---------------------------------------------------------------------------
   Desktop cart hover-preview.

   Binds to every [data-cart-preview-group] (the cart icon + its popover). On
   hover it opens the popover, re-fetches /cart.js so the contents are fresh,
   and listens for the site-wide `cart:refresh` event (dispatched by the PLP /
   PDP add-to-cart flows) to re-render while open. Qty +/- and Remove hit
   /cart/change.js and dispatch `cart:refresh` so the header cart badge stays in
   sync (see sections/header.liquid renderCartCount / refreshCartCount).

   Desktop-only: the whole thing is gated on (hover: hover) and (min-width: 1024px);
   the matching CSS in snippets/cart-preview.liquid also hides it below 1024px.
   Idempotent — safe to include once per header that renders the snippet.
   ------------------------------------------------------------------------- */
(function () {
  if (window.pfCartPreviewBound) return;
  window.pfCartPreviewBound = true;

  var MQ = window.matchMedia('(hover: hover) and (min-width: 1024px)');
  if (!MQ.matches) {
    if (MQ.addEventListener) MQ.addEventListener('change', maybeBoot);
    else if (MQ.addListener) MQ.addListener(maybeBoot);
    return;
  }

  function maybeBoot(e) {
    if (!e || e.matches) boot();
  }

  // Money format mirrors the theme's `| money` output, e.g. "Rs. 1,599.00".
  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Rs. ' + parts.join('.');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cssEscape(s) {
    return String(s).replace(/(["\\\[\]])/g, '\\$1');
  }

  function continueShoppingHref() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root + 'collections/all';
    return '/collections/all';
  }

  // variant id -> transparent PLP bottle cutout URL, server-rendered by
  // snippets/cart-preview.liquid ([data-cart-preview-images]). /cart.js has no
  // metafields, so this is how a re-rendered line keeps the same cutout the
  // server-rendered one shows; a variant missing here falls back to the
  // line's own image.
  var cutoutImages = null;
  function cutoutFor(item) {
    if (cutoutImages === null) {
      cutoutImages = {};
      var node = document.querySelector('[data-cart-preview-images]');
      if (node) {
        try { cutoutImages = JSON.parse(node.textContent) || {}; } catch (e) { cutoutImages = {}; }
      }
    }
    var id = item && (item.variant_id || item.id);
    var src = id != null ? cutoutImages[String(id)] : null;
    return typeof src === 'string' && src ? src : null;
  }

  function itemImage(item) {
    var cutout = cutoutFor(item);
    if (cutout) {
      var cutoutSrc = cutout.indexOf('//') === 0 ? 'https:' + cutout : cutout;
      return '<img src="' + esc(cutoutSrc) + '" alt="" />';
    }
    if (!item.image) return '<span class="cart-preview__thumb-fallback" aria-hidden="true"></span>';
    var src = item.image;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src.indexOf('?') === -1) src += '?width=128&height=128';
    else if (src.indexOf('width=') === -1) src += '&width=128&height=128';
    return '<img src="' + esc(src) + '" alt="" />';
  }

  function renderItem(item) {
    var variant = item.variant_title
      ? '<p class="cart-preview__variant">' + esc(item.variant_title) + '</p>'
      : '';
    var decDisabled = item.quantity <= 1 ? ' disabled' : '';
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    // An app-owned free gift. Its quantity belongs to the promotion engine:
    // stepping it up makes the line non-zero, which trips the charge fail-safe
    // and withdraws every reward for the session. Show the count, not a control.
    var isReward = !!(item.properties && item.properties['_pristine_preorder_auto']);
    var quantityControl = isReward
      ? '<div class="cart-preview__qty cart-preview__qty--reward" role="group">' +
          '<span class="cart-preview__qty-val" data-cart-preview-qty>' + item.quantity + '</span>' +
          '<span class="cart-preview__reward-badge">Free gift</span>' +
        '</div>'
      : '<div class="cart-preview__qty" role="group">' +
          '<button type="button" class="cart-preview__step" data-cart-preview-action="decrement" data-key="' + esc(item.key) + '"' + decDisabled + ' aria-label="Decrease quantity">−</button>' +
          '<span class="cart-preview__qty-val" data-cart-preview-qty>' + item.quantity + '</span>' +
          '<button type="button" class="cart-preview__step" data-cart-preview-action="increment" data-key="' + esc(item.key) + '" aria-label="Increase quantity">+</button>' +
        '</div>';
    return (
      '<div class="cart-preview__item" data-cart-preview-line data-key="' + esc(item.key) + '"' +
        ' data-variant-id="' + esc(item.variant_id || item.id) + '"' +
        ' data-selling-plan-id="' + esc(sellingPlan && sellingPlan.id || '') + '"' +
        ' data-line-properties="' + esc(JSON.stringify(item.properties || {})) + '">' +
        '<a class="cart-preview__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + itemImage(item) + '</a>' +
        '<div class="cart-preview__meta">' +
          '<a class="cart-preview__name" href="' + esc(item.url) + '">' + esc(item.product_title || item.title) + '</a>' +
          variant +
          quantityControl +
        '</div>' +
        '<div class="cart-preview__right">' +
          '<span class="cart-preview__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="cart-preview__remove" data-cart-preview-action="remove" data-key="' + esc(item.key) + '" aria-label="Remove">Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function render(root, cart) {
    var itemsEl = root.querySelector('[data-cart-preview-items]');
    var foot = root.querySelector('[data-cart-preview-foot]');
    var sub = root.querySelector('[data-cart-preview-subtotal]');
    var countEl = root.querySelector('[data-cart-preview-count]');
    var items = (cart && cart.items) || [];

    if (items.length === 0) {
      itemsEl.innerHTML =
        '<div class="cart-preview__empty">' +
          '<p class="cart-preview__empty-text">Your cart is empty</p>' +
          '<a class="cart-preview__empty-link" href="' + esc(continueShoppingHref()) + '">Continue shopping</a>' +
        '</div>';
      if (foot) foot.hidden = true;
    } else {
      itemsEl.innerHTML = items.map(renderItem).join('');
      if (foot) foot.hidden = false;
    }

    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (countEl) {
      var n = cart.item_count;
      countEl.textContent = n === 0 ? 'Empty' : n === 1 ? '1 item' : n + ' items';
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  var desiredQuantityByLine = new Map();
  var changeQueueRunning = false;

  function runCartMutation(operation) {
    var api = window.PristinePreorderCart;
    return api && typeof api.withCartMutation === 'function'
      ? api.withCartMutation(operation)
      : operation();
  }

  function normalizedProperties(value) {
    var properties = value && typeof value === 'object' ? value : {};
    return Object.keys(properties).sort().reduce(function (result, key) {
      if (properties[key] != null && properties[key] !== '') result[key] = String(properties[key]);
      return result;
    }, {});
  }

  function readLineIdentity(line) {
    var properties = {};
    try { properties = JSON.parse(line.getAttribute('data-line-properties') || '{}'); } catch (_) {}
    return {
      variantId: String(line.getAttribute('data-variant-id') || ''),
      sellingPlanId: String(line.getAttribute('data-selling-plan-id') || ''),
      properties: JSON.stringify(normalizedProperties(properties))
    };
  }

  function itemMatchesIdentity(item, identity) {
    var sellingPlan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return String(item && (item.variant_id || item.id) || '') === identity.variantId
      && String(sellingPlan && sellingPlan.id || '') === identity.sellingPlanId
      && JSON.stringify(normalizedProperties(item && item.properties)) === identity.properties;
  }

  function resolveCurrentLine(cart, state) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.find(function (item) { return item.key === state.key; })
      || items.find(function (item) { return itemMatchesIdentity(item, state.lineIdentity); });
  }

  function applyDesiredQuantities(root) {
    desiredQuantityByLine.forEach(function (state) {
      var line = root.querySelector('[data-cart-preview-line][data-key="' + cssEscape(state.key) + '"]');
      var value = line && line.querySelector('[data-cart-preview-qty]');
      if (value && state.desired > 0) value.textContent = state.desired;
    });
  }

  function finishQueuedChange(state, cart) {
    desiredQuantityByLine.delete(state.identity);
    state.waiters.splice(0).forEach(function (resolve) { resolve(cart); });
  }

  function drainChangeQueue() {
    if (changeQueueRunning) return;
    var state = Array.from(desiredQuantityByLine.values()).find(function (entry) {
      return entry.sent !== entry.desired;
    });
    if (!state) return;

    changeQueueRunning = true;
    var sentQuantity = state.desired;
    state.sent = sentQuantity;
    runCartMutation(function () {
      return fetchCart().then(function (currentCart) {
        var currentLine = resolveCurrentLine(currentCart, state);
        if (!currentLine || !currentLine.key) throw new Error('line_changed');
        state.key = currentLine.key;
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: state.key, quantity: sentQuantity })
        });
      });
    })
      .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(function (cart) {
        var currentLine = sentQuantity > 0 && resolveCurrentLine(cart, state);
        if (currentLine && currentLine.key) state.key = currentLine.key;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        if (state.desired === sentQuantity) finishQueuedChange(state, cart);
      })
      .catch(function () { finishQueuedChange(state, null); })
      .then(function () {
        changeQueueRunning = false;
        drainChangeQueue();
      });
  }

  function changeCart(key, quantity, lineIndex, lineIdentity) {
    var identity = key;
    var state = desiredQuantityByLine.get(identity);
    if (!state) {
      state = { identity: identity, key: key, lineIndex: lineIndex, lineIdentity: lineIdentity, desired: quantity, sent: null, waiters: [] };
      desiredQuantityByLine.set(identity, state);
    }
    state.desired = quantity;
    var completed = new Promise(function (resolve) { state.waiters.push(resolve); });
    drainChangeQueue();
    return completed;
  }

  function initGroup(group) {
    var root = group.querySelector('[data-cart-preview]');
    if (!root || group.dataset.cartPreviewInit) return;
    group.dataset.cartPreviewInit = '1';

    var openTimer = null;
    var closeTimer = null;

    /* The panel is server-rendered with the cart as it was at page load, so it
       is already correct until something changes the cart. Fetching on every
       open put a round trip between the hover and the panel and made it
       visibly re-render each time; now the fetch happens only when the cart is
       known to have moved since the last render. */
    var stale = false;

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openTimer) clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        if (!stale) return;
        fetchCart().then(function (cart) {
          stale = false;
          render(root, cart);
        }).catch(function () {});
      }, 120);
    }

    function close() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
      }, 220);
    }

    group.addEventListener('mouseenter', open);
    group.addEventListener('mouseleave', close);
    group.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Qty +/- and Remove. The cart icon <a> itself still navigates to /cart on
    // click; these buttons stop propagation so they never trigger navigation.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-preview-action]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var action = btn.getAttribute('data-cart-preview-action');
      var key = btn.getAttribute('data-key');
      var lineEl = root.querySelector('[data-cart-preview-line][data-key="' + cssEscape(key) + '"]');
      var lineIndex = Array.prototype.indexOf.call(root.querySelectorAll('[data-cart-preview-line]'), lineEl);
      var qtyEl = lineEl && lineEl.querySelector('[data-cart-preview-qty]');
      var current = qtyEl ? Number(qtyEl.textContent) : 1;

      var next;
      if (action === 'increment') next = current + 1;
      else if (action === 'decrement') {
        if (current <= 1) return;
        next = current - 1;
      }
      else next = 0; // remove
      if (next < 0) next = 0;

      // Optimistic feedback while the request is in flight, carrying the same
      // count roll (cut 10f) the PDP and cart steppers use.
      if (qtyEl && action !== 'remove') {
        qtyEl.textContent = next;
        if (window.PFMotion) window.PFMotion.step(qtyEl, next >= current ? 1 : -1);
      }
      changeCart(key, next, lineIndex, readLineIdentity(lineEl)).then(function (cart) {
        if (cart) render(root, cart); // render() rebuilds the row with correct disabled state
      });
    });

    // Live refresh while open (and whenever the cart changes site-wide).
    document.addEventListener('cart:refresh', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart) { stale = false; render(root, cart); applyDesiredQuantities(root); return; }
      if (root.classList.contains('is-open')) {
        fetchCart().then(function (c) { stale = false; render(root, c); });
      } else {
        // Repaint on the next open rather than now, off screen.
        stale = true;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-cart-preview-group]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (MQ.addEventListener) MQ.addEventListener('change', maybeBoot);
  else if (MQ.addListener) MQ.addListener(maybeBoot);
})();
